'use strict';

var FlightLevelChartFilterFactory = function FlightLevelChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightDateRangeFilterFactory', 'FlightCabinFilterFactory', 'FlightLegFilterFactory', 'FlightDOWFilterFactory', 'FlightSeasonFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FlightLevelChart() {
    DemandFilter.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'flight-level-chart');
    this.registerFilters(injectedFilters);
  }
  FlightLevelChart.prototype = Object.create(DemandFilter.prototype);
  FlightLevelChart.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  return FlightLevelChart;
};
FlightLevelChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FlightLevelChartFilterFactory;